import { render, staticRenderFns } from "./PriceLabsStatus.vue?vue&type=template&id=238a8def&"
import script from "./PriceLabsStatus.vue?vue&type=script&lang=js&"
export * from "./PriceLabsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports